import React, { useEffect } from 'react';
import Request from '../../components/Request';

export default function QueueStats(props) {

	useEffect(() => {
		Request.apiv1Get('stats/auto_queue', null)
			.then((response) => {
				console.log('ther esponse', response);
			});
	}, []);

	return (
		<div className='container'>
			<div className='row'>
				<div className='col-md-12 text-center'>
					<h4>Rawr</h4>
				</div>
			</div>
		</div>
	);
}